document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('.collection-content');
  const grid = document.getElementById('collection-grid');
  if (!content || !grid) return;

  /* ── Filter panel toggle ─────────────────────────────────── */
  const filterToggle = document.getElementById('collection-filter-toggle');

  if (filterToggle) {
    filterToggle.addEventListener('click', () => {
      const isHidden = content.classList.toggle('filters-hidden');
      filterToggle.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
      filterToggle.classList.toggle('active', !isHidden);
    });
  }

  /* ── Collect product data from DOM ──────────────────────── */
  const cards = Array.from(grid.querySelectorAll('.collection-card'));

  const allProducts = cards.map((card) => ({
    el: card,
    price: parseFloat(card.dataset.price) || 0,
    available: card.dataset.available === 'true',
    title: card.dataset.title || '',
  }));

  /* ── Compute price bounds ───────────────────────────────── */
  const prices = allProducts.map((p) => p.price).filter((v) => v > 0);
  const maxPrice = prices.length ? Math.ceil(Math.max(...prices)) : 1000;

  const fromRange = document.getElementById('price-from-range');
  const toRange = document.getElementById('price-to-range');
  const fromInput = document.getElementById('price-from-input');
  const toInput = document.getElementById('price-to-input');
  const trackFill = document.getElementById('price-track-fill');

  [fromRange, toRange].forEach((el) => { if (el) el.max = maxPrice; });
  if (toRange) toRange.value = maxPrice;
  if (toInput) toInput.value = maxPrice;

  /* ── Availability counts ─────────────────────────────────── */
  const inStockCount = allProducts.filter((p) => p.available).length;
  const outStockCount = allProducts.length - inStockCount;
  const elIn = document.getElementById('count-in-stock');
  const elOut = document.getElementById('count-out-stock');
  if (elIn) elIn.textContent = inStockCount;
  if (elOut) elOut.textContent = outStockCount;

  /* ── State ───────────────────────────────────────────────── */
  const state = {
    showInStock: true,
    showOutOfStock: false,
    priceFrom: 0,
    priceTo: maxPrice,
    sortBy: 'featured',
  };

  /* ── Render ──────────────────────────────────────────────── */
  function render() {
    const visible = allProducts.filter((p) => {
      const availMatch = (p.available && state.showInStock) || (!p.available && state.showOutOfStock);
      if (!availMatch) return false;
      return p.price >= state.priceFrom && p.price <= state.priceTo;
    });

    const sorted = visible.slice();
    if (state.sortBy === 'price-low-high') sorted.sort((a, b) => a.price - b.price);
    if (state.sortBy === 'price-high-low') sorted.sort((a, b) => b.price - a.price);
    if (state.sortBy === 'name-a-z') sorted.sort((a, b) => a.title.localeCompare(b.title));
    if (state.sortBy === 'name-z-a') sorted.sort((a, b) => b.title.localeCompare(a.title));

    allProducts.forEach((p) => { p.el.style.display = 'none'; });
    sorted.forEach((p) => { p.el.style.display = ''; grid.appendChild(p.el); });

    const n = sorted.length;
    const label = n > 99 ? n + '+ Products' : n + ' ' + (n === 1 ? 'Product' : 'Products');
    const countEl = document.getElementById('collection-count-label');
    if (countEl) countEl.textContent = label;

    updateTrack();
  }

  function updateTrack() {
    if (!trackFill || !fromRange) return;
    const span = Math.max(parseInt(fromRange.max, 10), 1);
    const startPct = (state.priceFrom / span) * 100;
    const endPct = (state.priceTo / span) * 100;
    trackFill.style.left = startPct + '%';
    trackFill.style.right = (100 - endPct) + '%';
  }

  /* ── Availability checkboxes ─────────────────────────────── */
  const checkIn = document.getElementById('filter-in-stock');
  const checkOut = document.getElementById('filter-out-stock');
  if (checkIn) checkIn.addEventListener('change', function () { state.showInStock = this.checked; render(); });
  if (checkOut) checkOut.addEventListener('change', function () { state.showOutOfStock = this.checked; render(); });

  /* ── Price range sliders ─────────────────────────────────── */
  function syncFrom(val) {
    const v = Math.max(0, parseInt(val, 10) || 0);
    state.priceFrom = v;
    if (v > state.priceTo) {
      state.priceTo = v;
      if (toRange) toRange.value = v;
      if (toInput) toInput.value = v;
    }
    if (fromRange) fromRange.value = v;
    if (fromInput) fromInput.value = v;
  }

  function syncTo(val) {
    const v = Math.max(0, Math.min(parseInt(val, 10) || 0, maxPrice));
    state.priceTo = v;
    if (v < state.priceFrom) {
      state.priceFrom = v;
      if (fromRange) fromRange.value = v;
      if (fromInput) fromInput.value = v;
    }
    if (toRange) toRange.value = v;
    if (toInput) toInput.value = v;
  }

  if (fromRange) fromRange.addEventListener('input', function () { syncFrom(this.value); render(); });
  if (toRange) toRange.addEventListener('input', function () { syncTo(this.value); render(); });
  if (fromInput) fromInput.addEventListener('input', function () { syncFrom(this.value); render(); });
  if (toInput) toInput.addEventListener('input', function () { syncTo(this.value); render(); });

  /* ── Sort dropdown ───────────────────────────────────────── */
  const sortBtn = document.getElementById('collection-sort-btn');
  const sortMenu = document.getElementById('collection-sort-menu');
  const sortWrap = document.getElementById('collection-sort-wrap');

  function closeSortMenu() {
    if (sortMenu) sortMenu.hidden = true;
    if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
  }

  if (sortBtn) {
    sortBtn.addEventListener('click', () => {
      const open = !sortMenu.hidden;
      if (open) {
        closeSortMenu();
      } else {
        sortMenu.hidden = false;
        sortBtn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  if (sortMenu) {
    sortMenu.querySelectorAll('.collection-sort-option').forEach((btn) => {
      btn.addEventListener('click', function () {
        state.sortBy = this.dataset.sort;
        sortMenu.querySelectorAll('.collection-sort-option').forEach((b) => { b.dataset.active = 'false'; });
        this.dataset.active = 'true';
        closeSortMenu();
        render();
      });
    });
  }

  document.addEventListener('mousedown', (e) => {
    if (sortWrap && !sortWrap.contains(e.target)) closeSortMenu();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSortMenu();
  });

  /* ── Initial render ──────────────────────────────────────── */
  render();
});
